export default __webpack_public_path__ + "static/Bg-and-dubai-d9524763c54c9a6d7d54b804087e13c9.webp";